import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Shield, Lock, Eye, UserCheck, Database, Cookie } from 'lucide-react';
export const Privacy = () => {
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-496">
      <Helmet data-id="element-497">
        <title data-id="element-498">Privacy & Cookie Policy | Taskpoint Appliance Repairs</title>
        <meta name="description" content="How Taskpoint protects your data. UK appliance repair service privacy policy covering data collection, usage, and your rights under GDPR." data-id="element-499" />
        <meta name="keywords" content="appliance repair privacy, UK data protection, washing machine engineer, GDPR compliance, secure appliance service, cookie policy" data-id="element-500" />
      </Helmet>
      <Header data-id="element-501" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-502">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-503">
          <h1 className="text-5xl font-bold mb-6" data-id="element-504">Privacy & Cookie Policy</h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-505">
            How we protect and use your information
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-506">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-507">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-508">
            <div className="space-y-8" data-id="element-509">
              <div data-id="element-510">
                <div className="flex items-center space-x-3 mb-4" data-id="element-511">
                  <UserCheck className="w-8 h-8 text-teal-600" data-id="element-512" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-513">
                    Who We Are
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-514">
                  Taskpoint is a UK appliance repair business committed to
                  protecting your privacy and handling your data responsibly. We
                  provide domestic diagnostics, repair, and maintenance services
                  only.
                </p>
              </div>
              <div data-id="element-515">
                <div className="flex items-center space-x-3 mb-4" data-id="element-516">
                  <Database className="w-8 h-8 text-teal-600" data-id="element-517" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-518">
                    Data We Collect
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-519">
                  We collect only what's necessary to manage your repair
                  bookings:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-520">
                  <li className="flex items-start space-x-2" data-id="element-521">
                    <span className="text-teal-600 mt-1" data-id="element-522">•</span>
                    <span data-id="element-523">Contact information (name, email, phone number)</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-524">
                    <span className="text-teal-600 mt-1" data-id="element-525">•</span>
                    <span data-id="element-526">Service address and postcode</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-527">
                    <span className="text-teal-600 mt-1" data-id="element-528">•</span>
                    <span data-id="element-529">
                      Payment confirmations (processed securely by Stripe)
                    </span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-530">
                    <span className="text-teal-600 mt-1" data-id="element-531">•</span>
                    <span data-id="element-532">Booking and service history</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-533">
                <div className="flex items-center space-x-3 mb-4" data-id="element-534">
                  <Eye className="w-8 h-8 text-teal-600" data-id="element-535" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-536">
                    How We Use Your Data
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-537">
                  We use your information to:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-538">
                  <li className="flex items-start space-x-2" data-id="element-539">
                    <span className="text-teal-600 mt-1" data-id="element-540">•</span>
                    <span data-id="element-541">Manage repair bookings and appointments</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-542">
                    <span className="text-teal-600 mt-1" data-id="element-543">•</span>
                    <span data-id="element-544">Carry out diagnostics and repair work</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-545">
                    <span className="text-teal-600 mt-1" data-id="element-546">•</span>
                    <span data-id="element-547">Send important service updates</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-548">
                    <span className="text-teal-600 mt-1" data-id="element-549">•</span>
                    <span data-id="element-550">Comply with legal obligations</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-551">
                <div className="flex items-center space-x-3 mb-4" data-id="element-552">
                  <Shield className="w-8 h-8 text-teal-600" data-id="element-553" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-554">
                    Data Sharing
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-555">
                  We do not sell your data. We may share limited information
                  with trusted service providers (e.g., payment processors,
                  hosting services) only to deliver our repair services
                  effectively.
                </p>
              </div>
              <div data-id="element-556">
                <div className="flex items-center space-x-3 mb-4" data-id="element-557">
                  <Cookie className="w-8 h-8 text-teal-600" data-id="element-558" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-559">Cookies</h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-560">
                  We use essential and analytics cookies to improve site
                  performance and user experience:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-561">
                  <li className="flex items-start space-x-2" data-id="element-562">
                    <span className="text-teal-600 mt-1" data-id="element-563">•</span>
                    <span data-id="element-564">
                      Essential cookies for site functionality and security
                    </span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-565">
                    <span className="text-teal-600 mt-1" data-id="element-566">•</span>
                    <span data-id="element-567">
                      Analytics cookies to understand how visitors use our site
                    </span>
                  </li>
                </ul>
                <p className="text-slate-600 mt-4" data-id="element-568">
                  You can control cookies through your browser settings. Some
                  site features may be affected if you disable cookies.
                </p>
              </div>
              <div data-id="element-569">
                <div className="flex items-center space-x-3 mb-4" data-id="element-570">
                  <UserCheck className="w-8 h-8 text-teal-600" data-id="element-571" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-572">
                    Your Rights
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-573">
                  Under UK GDPR, you have the right to:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-574">
                  <li className="flex items-start space-x-2" data-id="element-575">
                    <span className="text-teal-600 mt-1" data-id="element-576">•</span>
                    <span data-id="element-577">Access your personal data</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-578">
                    <span className="text-teal-600 mt-1" data-id="element-579">•</span>
                    <span data-id="element-580">Request corrections to your data</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-581">
                    <span className="text-teal-600 mt-1" data-id="element-582">•</span>
                    <span data-id="element-583">Request deletion of your data</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-584">
                    <span className="text-teal-600 mt-1" data-id="element-585">•</span>
                    <span data-id="element-586">Restrict or object to processing</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-587">
                    <span className="text-teal-600 mt-1" data-id="element-588">•</span>
                    <span data-id="element-589">Data portability where applicable</span>
                  </li>
                </ul>
                <p className="text-slate-600 mt-4" data-id="element-590">
                  To exercise your rights, contact us at:{' '}
                  <a href="mailto:Benjobalolong082@gmail.com" className="text-teal-600 hover:underline break-all" data-id="element-591">
                    Benjobalolong082@gmail.com
                  </a>{' '}
                  |{' '}
                  <a href="tel:08000554969" className="text-teal-600 hover:underline" data-id="element-592">
                    0800 055 4969
                  </a>
                </p>
              </div>
              <div data-id="element-593">
                <div className="flex items-center space-x-3 mb-4" data-id="element-594">
                  <Lock className="w-8 h-8 text-teal-600" data-id="element-595" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-596">
                    Data Retention & Security
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-597">
                  We retain your data only as long as necessary for service
                  delivery and legal compliance. We protect your information
                  with appropriate technical and organisational security
                  measures.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-598" />
    </div>;
};